<template>
  <div>
    <div>
      <b-sidebar id="sidebar-right" :title="title" right shadow>
        <div class="px-6 py-6">
          <component :is="view"></component> 
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
//  import * as d3 from 'd3';

// import ProjectDownloadsDrawer from '@/drawers/ProjectDownloadsDrawer.vue';
import ViabilityHeatmapDrawer from '@/drawers/ViabilityHeatmapDrawer.vue';
import DoseResponseDrawer from '@/drawers/DoseResponseDrawer.vue';
import DoseResponseComboDrawer from '@/drawers/DoseResponseComboDrawer.vue';
import LineageEnrichmentDrawer from '@/drawers/LineageEnrichmentDrawer.vue';
import MutationEffectDrawer from '@/drawers/MutationEffectDrawer.vue';
import CorrelationAnalysisDrawer from '@/drawers/CorrelationAnalysisDrawer.vue';
import MultivariateBiomarkerAnalysisDrawer from '@/drawers/MultivariateBiomarkerAnalysisDrawer.vue';
import SynergyByDoseDrawer from '@/drawers/SynergyByDoseDrawer.vue';
import ContinuousAssociationsDrawer from '@/drawers/ContinuousAssociationsDrawer.vue';
import RandomForestModelsDrawer from '@/drawers/RandomForestModelsDrawer.vue';

import { getPageDrawerFromId } from "@/js/utils/portal-constants";


export default {
  name: 'DetailsDrawer',
  components: {
    // ProjectDownloadsDrawer,
    DoseResponseDrawer,
    DoseResponseComboDrawer,
    ViabilityHeatmapDrawer,
    LineageEnrichmentDrawer,
    ContinuousAssociationsDrawer,
    MultivariateBiomarkerAnalysisDrawer,
    CorrelationAnalysisDrawer,
    MutationEffectDrawer,
    RandomForestModelsDrawer,
    SynergyByDoseDrawer
  },
  props: {
    expanded: Boolean,
    metadata: Object,
    title: String
  },
  data: () => ({
    drawer: true,
    mini: false,
  }),
  computed: {
      view(){
        if (this.metadata.screen.type==="CPS" && this.$route.params.pert_id.includes("_") && this.metadata.section.id=="dose-response"){
          return `${this.metadata.section.id}-combo-drawer` 
        } else {
          return getPageDrawerFromId(this.metadata.section.id)
        }
      },
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
